import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup
} from '@material-ui/core';
import React, { Dispatch, SetStateAction } from 'react';
import { AnalysisFilterState } from '../../../pages/AnalysisPage/Filter/analysisFilterState';

export interface RankIntervalRadiosProps {
  analysisFilterState: AnalysisFilterState;
  setAnalysisFilterState: Dispatch<SetStateAction<AnalysisFilterState>>;
}

export const RankIntervalRadios: React.FC<RankIntervalRadiosProps> = ({
  analysisFilterState,
  setAnalysisFilterState,
}) => {

  return (
    <RadioGroup
      value={analysisFilterState?.rankSumIntervals}
      onChange={(event: any) => {
        setAnalysisFilterState((prev) => ({
          ...prev,
          rankSumIntervals: event.target.value,
        }));
      }}
    >
      <Grid container>
        <Grid item>
          <FormControlLabel
            value="0"
            control={<Radio size={'small'} color={'default'} />}
            label="1-30"
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            value="1"
            control={<Radio size={'small'} color={'default'} />}
            label="31+"
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            value="2"
            control={<Radio size={'small'} color={'default'} />}
            label="100+"
          />
        </Grid>
      </Grid>
    </RadioGroup>
  );
};

export default RankIntervalRadios;
